//**********************************************************************//
//**                                                                  **//
//** Must Include: https://resources.emaze.com/emaze-fonts/fonts.js   **//
//**                                                                  **//
//**********************************************************************//

import React, { Component } from 'react'
import { Box, Select, MenuItem } from '@material-ui/core'

class FontPicker extends Component{
    state = {
        fonts: []
    }

    UNSAFE_componentWillMount(){
        if(window.ThemeFonts && window.ThemeFonts.length > 0){
            let selectedFont = window.ThemeFonts.find((font) => { return this.props.font.name && font.name.toLowerCase() === this.props.font.name.toLowerCase() })

            if(!selectedFont)
                selectedFont = { ...window.ThemeFonts[0] }
            this.setState({fonts: [...window.ThemeFonts], selectedFont})
            if(this.props.onChange)
                this.props.onChange({...selectedFont})
        }
    }

    handleChange = (event) => {
        this.setState({selectedFont: {...event.target.value}})
        if(this.props.onChange)
            this.props.onChange({...event.target.value})
    }

    render(){
        return(
            <Box >
                <Select className={this.props.className} 
                    value={this.state.selectedFont}  
                    onChange={this.handleChange}
                    rendervalue={(font) => {return font.display}}
                    style={{fontFamily: this.state.selectedFont.value}}
                >
                    {
                        window.ThemeFonts.map((font) => {
                            let styles = {
                                fontFamily: font.value
                            }
                            return (
                                <MenuItem 
                                    key={font.name} 
                                    value={font}
                                    style={styles}
                                >
                                    {font.display}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </Box>
        )
    }

}

export default FontPicker